export default "Comparez les offres élec/gaz pour vos immeubles tertiaires. Audit TURPE/ATRD multi-sites, optimisation profil de puissance, courtier indépendant des fournisseurs d'énergie.";
